export const FEEDBACK_REPORT_TYPES = [
  'pronunciation',
  'citation',
  'other',
] as const;
